import _extends from "@babel/runtime/helpers/extends";
/** @jsx jsx */

import { jsx } from '@emotion/core';
import { getPageLayoutSlotSelector } from '../../common/utils';
import { useSkipLink } from '../../controllers';
import { mainStyles } from './styles';

var Main = function Main(props) {
  var children = props.children,
      testId = props.testId,
      id = props.id,
      skipLinkTitle = props.skipLinkTitle;
  useSkipLink(id, skipLinkTitle);
  return jsx("div", _extends({
    "data-testid": testId,
    css: mainStyles,
    id: id
  }, getPageLayoutSlotSelector('main')), children);
};

export default Main;